import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { lastValueFrom, retry } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class UsuariosService {

  constructor(private http: HttpClient) { }


  /**
 * Guardar datos usuarios
 * @param datos
 * @returns
 */
  guardar(body: any): Promise<any>{
    return lastValueFrom(
      this.http.post<any>(`${environment.API_DOMAINS.URL_USUARIOS}/saveUsuario`, body).pipe(retry(1))
    );
  }

  obtener(id: number) {
    return this.http.get<any>(`${environment.API_DOMAINS.URL_USUARIOS}/getUsuario/${id}`);
  }

  getUsuarioById(id: string): Promise<any> {
    const params = new HttpParams().set('id', id);
    return lastValueFrom(
      this.http.get<any>(`${environment.API_DOMAINS.URL_USUARIOS}/getUsuario`, { params }).pipe(retry(1))
    );
  }

  obtenerPorEmail(email: string) {
    return this.http.get<any>(`${environment.API_DOMAINS.URL_USUARIOS}/getByEmail?email=${email}`);
  }

  async listarUsuarios(props?: {
    page?: number;
    limit?: number;
    nombre?: string;
  }): Promise<any[]> {
    let params: HttpParams = new HttpParams();
    if (props?.limit) {
      params = params.set('limit', props.limit.toString());
    }
    if (props?.page) {
      params = params.set('page', props.page.toString());
    }
    if (props) {
      Object.entries(props).forEach(([key, value]) => {
        if (
          value &&
          key !== 'limit' &&
          key !== 'page' &&
          value !== ''
        ) {
          params = params.set(key, value.toString());
        }
      });
    }
    const res = await lastValueFrom(
      this.http.get<any[]>(`${environment.API_DOMAINS.URL_USUARIOS}/listUsuario`, { params }).pipe()
    );
    return res;
  }

  async obtenerPerfiles(): Promise<any[]> { 
    const res = await lastValueFrom(
      this.http.get<any[]>(`${environment.API_DOMAINS.URL_USUARIOS}/listPerfil`).pipe(retry(1))
    ); 
    return res;
  }

  updateUsuario(body: any): Promise<any> {
    return lastValueFrom(
      this.http.put<any>(`${environment.API_DOMAINS.URL_USUARIOS}/editUsuario`, body).pipe(retry(1))
    );
  }
}
